import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const IngestIndexPage = lazy(() =>
  import('../../pages/admin/ingest/IngestIndexPage').then((m) => ({
    default: m.IngestIndexPage,
  })),
);

export const Route = createFileRoute('/admin/ingest')({
  component: () => (
    <Suspense
      fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%', transform: 'translateX(-50%)' }} />}
    >
      <IngestIndexPage />
    </Suspense>
  ),
});
